'use client';
import { AdjustmentsHorizontalIcon } from '@heroicons/react/24/solid';
import { useTranslations } from 'next-intl';

import { Button } from '@/components/atoms/Button';
import { HeroIcon } from '@/components/atoms/Icon';
import { Dropdown } from '@/components/molecules/Dropdown';

import type { TrackFileType } from '@/lib/api';

interface Props {
  availableFormats: TrackFileType[];
  preferredRendition?: TrackFileType;
  handleOnRenditionSelect?: (format: TrackFileType) => void;
}

export function PlayerSettingsMenuButtonAudio({
  availableFormats,
  preferredRendition,
  handleOnRenditionSelect = () => {},
}: Props) {
  const t = useTranslations();

  return (
    <Dropdown>
      <Dropdown.Trigger as={Button} variant="ghost">
        <HeroIcon icon={AdjustmentsHorizontalIcon} />
      </Dropdown.Trigger>
      <Dropdown.Content
        title={t('PLAYER_SETTINGS_QUALITY')}
        side="top"
        align="end"
        sideOffset={0}
        className="z-[1400] min-w-[170px] bg-(--player-menu-background-default) p-1"
      >
        {availableFormats.map(availableFormat => (
          <Dropdown.Item
            key={availableFormat}
            isActive={availableFormat === preferredRendition}
            onSelect={() => handleOnRenditionSelect(availableFormat)}
            className="px-[1em] py-[.4em] text-(--player-menu-item-text-color-default)"
          >
            {availableFormat.toUpperCase()}
          </Dropdown.Item>
        ))}
      </Dropdown.Content>
    </Dropdown>
  );
}
